export function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 rounded-full border-2 border-amber-400/30 border-t-amber-400 animate-spin" />
        <span className="text-xs uppercase tracking-[0.3em] text-amber-400/70">MoYo Stars Date</span>
      </div>
    </div>
  );
}
